// extracted by mini-css-extract-plugin
export default {"active":"Navbar_active__0RkTf","default":"Navbar_default__mHdCH"};